import { User } from '@/domain/types/user';
import { utils, writeFile } from 'xlsx';

export function exportUsersToExcel(users: User[]) {
  const data = users.map((user) => ({
    Documento: user.document,
    Nombre: user.name,
    Apellido: user.lastname,
    'Correo electrónico': user.email,
    Departamento: user.department,
    Área: user.area,
    Unidad: user.unit,
    Cargo: user.position,
  }));
  const ws = utils.json_to_sheet(data);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, 'Usuarios');
  writeFile(wb, 'usuarios-que-han-ingresado.xlsx');
}
